import cn from 'classnames'
import {FC} from 'react'

import {theme} from '@/theme/theme'

type SpinnerProps = {
  color?: string
  size?: 'small' | 'medium'
}

export const Spinner: FC<SpinnerProps> = ({
  color = theme.palette.button.primary.contrastText,
  size = 'medium',
}) => {
  return (
    <>
      <div className={cn('wrapper', size)}>
        <div className="spinner">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
          height: 24px;
          width: auto;
          top: 0;
          left: 0;
        }
        .spinner {
          display: flex;
          justify-content: center;
          position: relative;
          width: 24px;
          height: 24px;
          margin: 0 auto;
        }
        .spinner span {
          display: block;
          transform-origin: 0 12px;
          animation: spin 0.8s linear infinite;
        }
        /* Keeps turning under the global reduced-motion rule in styles.css: it's a fade, not
           movement, and the only sign that something is loading */
        @media (prefers-reduced-motion: reduce) {
          .spinner span {
            animation-duration: 0.8s !important;
            animation-iteration-count: infinite !important;
          }
        }
        .spinner span:after {
          border-radius: 40%;
          background-color: ${color};
          content: ' ';
          display: block;
          position: absolute;
          height: 7px;
          width: 2px;
          left: -1px;
          top: 0;
        }
        .small {
          height: 20px;
        }
        .small .spinner {
          width: 20px;
          height: 20px;
        }
        .small .spinner span {
          transform-origin: 0 10px;
        }
        .small .spinner span:after {
          height: 6px;
        }
        .spinner span:nth-child(1) {
          transform: rotate(0deg);
          animation-delay: -0.7s;
        }
        .spinner span:nth-child(2) {
          transform: rotate(45deg);
          animation-delay: -0.6s;
        }
        .spinner span:nth-child(3) {
          transform: rotate(90deg);
          animation-delay: -0.5s;
        }
        .spinner span:nth-child(4) {
          transform: rotate(135deg);
          animation-delay: -0.4s;
        }
        .spinner span:nth-child(5) {
          transform: rotate(180deg);
          animation-delay: -0.3s;
        }
        .spinner span:nth-child(6) {
          transform: rotate(225deg);
          animation-delay: -0.2s;
        }
        .spinner span:nth-child(7) {
          transform: rotate(270deg);
          animation-delay: -0.1s;
        }
        .spinner span:nth-child(8) {
          transform: rotate(315deg);
          animation-delay: 0s;
        }
        @keyframes spin {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
    </>
  )
}
